import { RitornoPaginazione } from 'src/app/shared/models/RitornoPaginazione';
import { Corriere } from './../Models/Corriere';
import { ApiRestService } from './api-rest.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Spedizione } from '../Models/Spedizione';
import {Filtri_Spedizione} from "../Models/Filtri_Spedizione";
@Injectable({
  providedIn: 'root'
})
export class SpedizioniStoreService {
  constructor(private ApiRestService: ApiRestService) { }
  private EDITABLE = new BehaviorSubject<boolean>(false);
  private ADDABLE = new BehaviorSubject<boolean>(false);
  private CORRIERI = new BehaviorSubject<Corriere[]>([]);
  private SPEDIZIONI = new BehaviorSubject<RitornoPaginazione<Spedizione[]>>({total:0, data:[], nuovi:0, lavorare: 0 })
  private SPEDIZIONE = new BehaviorSubject<Spedizione>(null);
  private FILTRI = new BehaviorSubject<Filtri_Spedizione>(new Filtri_Spedizione(1,10));

  private dataStore: {
    Editable: boolean,
    Addable: boolean,
    Corrieri: Corriere[],
    Spedizioni: RitornoPaginazione<Spedizione[]>,
    Spedizione: Spedizione,
    Filtri: Filtri_Spedizione
  } = {
      Editable: false,
      Addable: false,
      Corrieri: [],
      Spedizioni: { total: 0, data: [], nuovi:0, lavorare: 0 },
      Spedizione: null,
      Filtri: new Filtri_Spedizione(1,10)
    }
  readonly $editable = this.EDITABLE.asObservable();
  readonly $addable = this.ADDABLE.asObservable();
  readonly $corrieri = this.CORRIERI.asObservable();
  readonly $spedizioni = this.SPEDIZIONI.asObservable();
  readonly $spedizione = this.SPEDIZIONE.asObservable();
  readonly $filtri = this.FILTRI.asObservable();
  refreshEditable = () => this.EDITABLE.next(Object.assign({}, this.dataStore).Editable);
  refreshAddable = () => this.ADDABLE.next(Object.assign({}, this.dataStore).Addable);
  refreshCorrieri = () => this.CORRIERI.next(Object.assign({}, this.dataStore).Corrieri);
  refreshSpedizioni = () => this.SPEDIZIONI.next(Object.assign({}, this.dataStore).Spedizioni);
  refreshSpedizione = () => this.SPEDIZIONE.next(Object.assign({}, this.dataStore).Spedizione);
  refreshFiltri = () => this.FILTRI.next(Object.assign({}, this.dataStore).Filtri);

  getCorrieri() {
    this.ApiRestService.getCorrieri().subscribe(data => {
      this.dataStore.Corrieri = data;
      this.refreshCorrieri();
    });
  }
  getSpedizioni(value) {
    this.ApiRestService.getListaSpedizioni(value).subscribe(data => {
      this.dataStore.Spedizioni = data;
      this.refreshSpedizioni();
    });
  }
  updateSpedizioneSelezionata(value: Spedizione) {
    if (value && value.id ){
      this.ApiRestService.getSpedizione(value).subscribe(data => {
        this.dataStore.Spedizione = data;
        this.refreshSpedizione();
      });
    }else {
      this.dataStore.Spedizione = value;
      this.refreshSpedizione();
    }
  }
  updateAddable(value: boolean) {
    this.dataStore.Addable = value;
    this.refreshAddable();
  }
  updateEditable(value: boolean) {
    this.dataStore.Editable = value;
    this.refreshEditable();
  }
  updateFiltri(value: Filtri_Spedizione) {
    this.dataStore.Filtri = value;
    this.refreshFiltri();
  }
}
